import Cookies from 'js-cookie'

const TokenKey = 'authorAccessToken'

export function getToken() {
  return localStorage.getItem(TokenKey)
}
export function getGustToken() {
  return localStorage.getItem('gustAccessToken')
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  if (localStorage.getItem(TokenKey)) {
    localStorage.removeItem(TokenKey)
  }
  return Cookies.remove(TokenKey)
}

export function getParkName() {
  return localStorage.getItem('activeParkName')
}
export function getParkId() {
  return localStorage.getItem('activeParkId')
}